import { css } from 'styled-components';
import { ANWBDefault } from '@anwb/theme';
import { NotificationIcon, NotificationTitle } from './notification.styled';
/**
 * Notification Info Variant
 */
export const infoVariantStyles = ({ theme }) => css `
	background-color: ${theme.colors.extralight.bgNotificationInformative};
	border-color: ${theme.colors.informative.borderNotification};

	${NotificationIcon} {
		color: ${theme.colors.informative.iconInformative};
	}

	${NotificationTitle} {
		color: ${theme.colors.informative.titleNotification};
	}
`;
/**
 * Notification Success Variant
 */
export const successVariantStyles = ({ theme }) => css `
	background-color: ${theme.colors.positive.bgNotification};
	border-color: ${theme.colors.positive.borderNotification};

	${NotificationIcon} {
		color: ${theme.colors.positive.iconNotification};
	}

	${NotificationTitle} {
		color: ${theme.colors.positive.titleNotification};
	}
`;
/**
 * Notification Error Variant
 */
export const errorVariantStyles = ({ theme }) => css `
	background-color: ${theme.colors.error.bgNotification};
	border-color: ${theme.colors.error.borderNotification};

	${NotificationIcon} {
		color: ${theme.colors.error.iconNotification};
	}

	${NotificationTitle} {
		color: ${theme.colors.error.titleNotification};
	}
`;
/**
 * Notification Warning Variant
 */
export const warningVariantStyles = ({ theme }) => css `
	background-color: ${theme.colors.warning.bgNotification};
	border-color: ${theme.colors.warning.borderNotification};

	${NotificationIcon} {
		color: ${theme.colors.warning.iconNotification};
	}

	${NotificationTitle} {
		color: ${theme.colors.warning.titleNotification};
	}
`;
/**
 * Notification Promotion Variant
 */
export const promotionVariantStyles = ({ theme }) => css `
	background-color: ${theme.name === ANWBDefault.name
    ? theme.colors.extralight.bgNotificationInformative
    : theme.colors.extralight.bgNotificationPromotional};
	border-color: ${theme.colors.informative.borderNotification};

	${NotificationIcon} {
		color: ${theme.name === ANWBDefault.name
    ? theme.colors.warning.iconNotification
    : theme.colors.informative.iconInformative};
	}

	${NotificationTitle} {
		color: ${theme.colors.warning.titleNotification};
	}
`;
//# sourceMappingURL=notification-variants.styled.js.map